export class AddEditSharedWorkspaceParametersDto {
    id: number;
    name: string;
    categoryCode: 'USR' | 'CB' | 'COMM' | 'PROP' | 'CCB';
    config: string;
    isSystemType: boolean;
    allowExternalUsers: boolean;
}
